var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('actor-detail-o-p-global',{attrs:{"itemsBreadcrumbs":_vm.itemsBreadcrumbs,"sBackHref":_vm.sBackHref,"bWithPathOrNameRoute":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }